import React from 'react';
import PropTypes from 'prop-types';
import './analytics-icon.scss';

function DecrementIcon({ onClick }) {
    return (
        <span onClick={onClick} className='analytics-icon'>
            <svg
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                tabIndex='-1'
                title='Sync'>
                <path fill="white" d='M19 13H5v-2h14v2z'>
                </path>
            </svg>
        </span>
    );
}


DecrementIcon.propTypes = {
    onClick: PropTypes.func
};

export default DecrementIcon;
